/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Button from "../Button";
import { ControlTable } from "../Table";
import Profile from "../Profile";
import systemAlert from "../../utils/systemAlert";
import useForm from "../../hooks/useForm";
import { getCompanyPersonInChargeList, deleteCompanyPersonInCharge } from "../../apis/admin/companies";

import CareCompanyPersonInChargePost from "./CareCompanyPersonInChargePost"
import { forEach, isEmpty } from "lodash";

const CareCompanyPersonInCharge = ({
  company,
  managerCompany,
}) => {

  const [open, setOpen] = useState(false)
  const [formType, setFormType] = useState("create")
  const [post, setPost] = useState(null)

  const [list, setList] = useState([]);
  const [fields, setFields] = useState([]);

  const { employees } = useSelector((store) => ({
    employees: store.Data.employees,
  }));

  useEffect(() => {
    setFields([
    { 
      title: "이름", 
      key: "employeeIdx",
        onValue: (value) => {
          return (
            <Profile employeeIdx={value} />
          );
        }
    },
    {
      title: "부서",
      key: "employeeIdx",
      onValue: (value, field, data) => {
        const employee = data.employee[0]
        if (!isEmpty(employee)) {
          return employee.partName;
        } else {
          return ""
        }
      },
    },
    {
      title: "직급",
      key: "employeeIdx",
      onValue: (value, field, data) => {
        const employee = data.employee[0]
        if (!isEmpty(employee)) {
          return employee.gradeName;
        } else {
          return ""
        }
      },
    },
    {
      title: "핸드폰",
      key: "employeeIdx",
      onValue: (value, field, data) => {
        const employee = data.employee[0]
        if (!isEmpty(employee)) {
          return employee.mobile;
        } else {
          return ""
        }
      },
    },
    {
      title: "전화번호",
      key: "employeeIdx",
      onValue: (value, field, data) => {
        const employee = data.employee[0]
        if (!isEmpty(employee)) {
          return employee.phone;
        } else {
          return ""
        }
      },
    },
    {
      title: "이메일",
      key: "employeeIdx",
      onValue: (value, field, data) => {
        const employee = data.employee[0]
        if (!isEmpty(employee)) {
          return employee.email;
        } else {
          return ""
        }
      },
    },
    {
      title: "메모",
      key: "memo",
      onValue: (value) => {
        const data = String(value)
        if (data.length > 10) {
          return data.slice(0, 10) + '..'
        } else {
          return data
        }
      },
    },
    {
      title: '작성일',
      key: 'createdTime',
      type: 'date'
    }
  ]);
  }, [list]);

  const _getData = () => {
    setIsLoading(true);
    setList([]);
    getCompanyPersonInChargeList(managerCompany.companyIdx)
      .then((res) => {
        const datas = res.data
        forEach(datas, item => {
          const employee = employees.find(employee => employee.idx === item.employeeIdx)
          if (employee) {
            item.employee = [employee]
          } else {
            item.employee = []
          }
        })
        setList(datas);
      })
      .catch((err) => {
        console.error(err.response);
      }).finally(() => {
        setIsLoading(false);
      });
  };

  const {
    setSubmit,
    handleSubmit,
    // LIST 용
    isLoading, setIsLoading,
  } = useForm()

  useEffect(() => {
    if (!isEmpty(company) && !isEmpty(employees)) {
      _getData()
      setSubmit(_getData)
    }
  }, [company, employees])

  const onRowClick = (data) => {
    setPost(data)
    setFormType("detail")
    setOpen(true)
  }

  const rowBtnConfig = {
    rowButtons: [
      {
        label: "수정",
        type: "edit",
        action: (data) => {
          setPost(data)
          setFormType("modify")
          setOpen(true)
        },
      },
      {
        label: "삭제",
        type: "delete",
        action: (data) => {
          systemAlert('해당 내역을 삭제 하시겠습니까?', {
            buttons: [
              {
                color: 'text',
                label: '취소'
              },
              {
                label: '확인',
                onClick: () => {
                  setIsLoading(true);
                  deleteCompanyPersonInCharge(managerCompany.companyIdx, data.idx)
                    .then(() => {
                      setIsLoading(false)
                      handleSubmit()
                    })
                    .catch((err) => { });
                }
              }
            ]
          })
        },
      },
    ],
  };

  return (
    <div className="care-company-addsiteinfo">
      <div className="header-wrap pb-12">
        <ul className="header-tab">
            <li className="header-item" > {"담당자 정보 관리"} </li>
        </ul>
        <div className="button-wrap">
          <Button
            style={{ lineHeight: '16px' }}
            onClick={() => { 
                setPost(null)
                setFormType("create"); 
                setOpen(true);
              }
            }
          >등록</Button>
        </div>
      </div>

      <ControlTable
        isLoading={isLoading}
        fields={fields}
        list={list}
        isControl={false}
        rowBtn={rowBtnConfig}
        onSelect={onRowClick}
      />
      <CareCompanyPersonInChargePost
        post={post}
        open={open} 
        setOpen={setOpen}
        submit={handleSubmit}
        orgMode={formType}
        managerCompany={managerCompany}
      />
    </div>
  );
};

export default CareCompanyPersonInCharge;
